import { useMemo } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { usePostOfficeContext } from '@atlassian/post-office-context/post-office-context';

import { getTracedContactSalesLink } from './get-traced-contact-sales-link';

export const useTracedContactSalesLink = (
	contactSalesUrl: string,
): ReturnType<typeof getTracedContactSalesLink> => {
	const { orgId } = usePostOfficeContext();
	const trackingEnabled = FeatureGates.checkGate('adminhub_enable_pls-org-tracking');

	return useMemo(
		() => getTracedContactSalesLink(contactSalesUrl, orgId, trackingEnabled),
		[contactSalesUrl, orgId, trackingEnabled],
	);
};
